module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"latest_sodium_meld_calculation_heading":"Allocation Score","smc_score_field":"Allocation Score","smc_score_source_field":"Allocation Score Source"},"fr":{"latest_sodium_meld_calculation_heading":"Pointage MELD","smc_score_field":"Pointage MELD","smc_score_source_field":"Provenance du pointage"}}')
  delete Component.options._Ctor
}
